module.exports = __webpack_public_path__ + "static/media/EricLee.549c2fc3.jpg";